/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_IssuingInputs */



/**
* | output |
* | --- |
* | "Issuing..." |
*
* @param {Sanction_Mgr_IssuingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_issuing = /** @type {((inputs?: Sanction_Mgr_IssuingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_IssuingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Émission...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Emitiendo...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Emitindo...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Emissione...")
	return /** @type {LocalizedString} */ ("Issuing...")
});